import { Tooltip } from "@/atoms"
import { isUnhealthy } from "@/domain/integration"
import { useTranslation } from "@/hooks/useTranslation"
import { WarningOutlined } from "@/icons"
import cn from "classnames"

import styles from "./HealthWarning.module.scss"

import type { HealthWarningProps } from "."

export const HealthWarning = ({
  health,
  className,
  icon: Icon = WarningOutlined
}: HealthWarningProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.configuration.health"
  })

  if (!isUnhealthy(health)) return null

  return (
    <Tooltip title={t(health.reason || "unknown")}>
      <Icon
        aria-label="installation-health"
        className={cn(styles.icon, className)}
      />
    </Tooltip>
  )
}
